import React from "react";
import { Navigation } from "../../components/navigation";
import JsonData from "../../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../../App.css";
import { projectStyle } from "../../style/projectStyle";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Success = () => {
  const project = JsonData.Projects.find(
    (proj) => proj.title === "S.U.C.C.E.S.S."
  );

  return (
    <div>
      <Navigation />
      <div className="container d-flex justify-content-center align-items-center flex-column" style={{ marginTop: "101px", minHeight: "80vh", gap: "40px" }}>
        {/* Main Content */}
        <div className="text-center">
          {/* Project Title */}
          <h1 className="display-4">{project?.title || "Project Title"}</h1>

          {/* Project Tagline/Short Description */}
          <p className="lead">
            {project?.description ||
              "A brief description of the project will go here."}
          </p>

          {/* Learn More Button */}
          <div>
            <a href={project?.orgLink} target="_blank" rel="noreferrer" className="btn btn-link btn-lg">
              Learn More
            </a>
          </div>

          {/* Project Image */}
          <div>
            <img
              src={project?.image}
              alt={project?.title}
              className="img-fluid shadow-lg"
              style={{ height: "200px", width: "auto", margin: "18px"}}
            />
          </div>
        </div>

        {/* Project Details Section */}
        <div style={projectStyle.container}>
          <h3>Our Project</h3>
          <p style={projectStyle.text}>
            {project?.projectDescription ||
              "This section contains a more detailed description of the project. Explain the project's goals, implementation, and any key milestones. You can also include future plans and the impact of the project on the community or organization it serves."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Success;